import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  cellDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& *': {
      maxWidth: 225,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      fontSize: theme.typography.pxToRem(12)
    }
  },
  statusWrapper: {
    color: theme.palette.success.dark,
    fontWeight: theme.typography.fontWeightSemiBold,
    '&.closed': {
      color: theme.palette.error.main,
    }
  },
  remaining:{
    marginLeft: theme.spacing(1.25),
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.dark,
  }
}))
